module.exports = __webpack_public_path__ + "static/media/AI_ML.507a69fe.jpg";